import { Navbar } from '@blueprintjs/core';
import * as React from 'react';

import { ProjectNavbarButtons } from 'src/containers/Project/ProjectNavbarButtons';
import { ProjectNavbarToggle } from 'src/containers/Project/ProjectNavbarToggle';
import { ProjectTitle } from 'src/containers/Project/ProjectTitle';

export const ProjectNavbar: React.VFC = () => {
  return (
    <Navbar className="sd-project-navbar">
      <Navbar.Group className="sd-project-navbar-left">
        <ProjectTitle />
      </Navbar.Group>

      <Navbar.Group className="sd-project-navbar-center">
        <ProjectNavbarToggle />
      </Navbar.Group>

      <Navbar.Group className="sd-project-navbar-right">
        <ProjectNavbarButtons />
      </Navbar.Group>
    </Navbar>
  );
};
